var $61a527d4db6297ee$exports = {};
$61a527d4db6297ee$exports = {
    "rangeOverflow": (args)=>`Vrijednost mora biti ${args.maxValue} ili ranije.`,
    "rangeReversed": `Datum po\u{10D}etka mora biti prije datuma zavr\u{161}etka.`,
    "rangeUnderflow": (args)=>`Vrijednost mora biti ${args.minValue} ili kasnije.`,
    "unavailableDate": `Odabrani datum nije dostupan.`
};


export {$61a527d4db6297ee$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
